import { getDevice } from '../../devices';

import { GetDevicePlacesRequest, GetDevicePlacesResponse } from './types';

export const getDevicePlaces = async (
  params: GetDevicePlacesRequest
): Promise<GetDevicePlacesResponse> => {
  const device = await getDevice({ deviceId: params.deviceId });
  return device.places;
};

